import { createPortal } from "react-dom";
import invitationCodeImg from "assets/products/shared/images/where-invitation-code.webp";
import { pushGTMEvent } from "utils/gtmEvent";
import { GA_EVENT_CONFIGS } from "constants/gaEvents";

const WhereInvitationCodeModal = () => {
    const handleOpenModal = () => {
        const modal = document.getElementById("where-invitation-code-modal") as HTMLDialogElement;
        if (modal) {
            modal.showModal();
            pushGTMEvent(GA_EVENT_CONFIGS.INVITATION_MODAL_OPEN);
        }
    };

    const handleCloseModal = () => {
        const modal = document.getElementById("where-invitation-code-modal") as HTMLDialogElement;
        if (modal) {
            modal.close();
            pushGTMEvent(GA_EVENT_CONFIGS.INVITATION_MODAL_CLOSE);
        }
    };

    return (
        <>
            <p
                className="text-sm leading-5 tracking-sm text-question-mark pr-2 font-bold cursor-pointer hover:underline"
                onClick={handleOpenModal}
                data-testid="where-invitation-code-modal-button"
            >
                Where is my invitation code?
            </p>

            {createPortal(
                <dialog id="where-invitation-code-modal" className="modal" data-testid="where-invitation-code-modal">
                    <div className="modal-box p-0">
                        <button
                            type="button"
                            autoFocus={false}
                            className="btn btn-sm text-secondary btn-ghost absolute right-3 top-3 z-10"
                            onClick={handleCloseModal}
                        >
                            ✕
                        </button>

                        <div className="w-full h-[304px] bg-gray-100 flex items-center justify-center relative">
                            <img
                                src={invitationCodeImg}
                                alt="Invitation code location"
                                className="w-full h-full object-cover tablet:object-fill"
                            />
                            <div className="absolute inset-0 bg-black bg-opacity-30"></div>
                        </div>

                        <div className="p-6">
                            <p className="font-medium text-base leading-6 text-black">
                                Your 10-digit Invitation Code can be found on the front page of the application you recently
                                received in the mail.
                            </p>
                        </div>
                    </div>
                    <form method="dialog" className="modal-backdrop">
                        <button type="submit">close</button>
                    </form>
                </dialog>,
                document.body
            )}
        </>
    );
};

export default WhereInvitationCodeModal;
